import React, { PureComponent } from 'react';
import Tab from '../../common/tab/Tab';
import AlertPersonal from './personal';
import AlertSystem from './system';

const tabs = {
  system: 1,
  personal: 2,
};

class SettingPopup extends PureComponent {
  state = {
    currentTab: tabs.system,
  };

  changeTab = tab => {
    this.setState({
      currentTab: tab,
    });
  };

  render() {
    const { currentTab } = this.state;
    const { showSetting } = this.props;

    return (
      <div className="setting-popup top-nav">
        <div className="setting-popup-content">
          <div className="header align-items-center justify-content-end d-flex">
            <i onClick={() => showSetting(false)} className="icon-close" />
          </div>

          <div className="body flex-fill d-flex flex-column">
            <div className="top-nav">
              <Tab
                locks={[2]}
                currentTab={currentTab}
                listTab="alerts.lstTab"
                changeTab={this.changeTab}
              />
            </div>

            <div className="d-flex flex-fill">
              {currentTab === tabs.system && <AlertSystem />}
              {currentTab === tabs.personal && <AlertPersonal />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SettingPopup.propTypes = {};

export default SettingPopup;
